<template>
  <img :src="src" :width="width" :height="height" :title="title" :alt="title" :class="['vc-image-placeholder']" />
</template>
<script>
export default {
  name: 'VcImagePlaceholder',
  data () {
    return {
      src: null,
      xmlns: 'http://www.w3.org/2000/svg'
    }
  },
  computed: {
    title () {
      return this.label || `${this.width} x ${this.height}`
    }
  },
  props: {
    width: {
      type: String,
      default: '300'
    },
    height: {
      type: String,
      default: '150'
    },
    border: {
      type: String,
      default: '4'
    },
    color: {
      type: String,
      default: '#666'
    },
    background: {
      type: String,
      default: '#d4d0c8'
    },
    label: {
      type: String,
      default: ''
    },
    font: {
      type: String,
      default: 'bold 24px Arial, Helvetica, Sans-serif'
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    /***
     * Create the image
     * @method render
     * @return void
     * */
    render () {
      const svg = this.create('svg')
      const rect = this.create('rect')
      const text = this.create('text')
      const width = '100%'
      const x = '50%'
      const color = this.color
      const fill = this.background
      const sAttrs = [{width}, {height: width}, {xmlns: this.xmlns}]
      const rAttrs = [{width}, {height: width}, {fill}]
      const tAttrs = [{width}, {height: width}, {fill: color}, {transform: 'translate(0, 9)'}, {x}, {y: x}]

      sAttrs.forEach(item => {
        this.attr(svg, Object.keys(item)[0], Object.values(item)[0])
      })
      rAttrs.forEach(item => {
        this.attr(rect, Object.keys(item)[0], Object.values(item)[0])
      })
      tAttrs.forEach(item => {
        this.attr(text, Object.keys(item)[0], Object.values(item)[0])
      })

      rect.style.strokeWidth = this.border
      rect.style.stroke = color
      text.style.textAnchor = 'middle'
      text.style.font = this.font
      text.innerHTML = this.title

      svg.appendChild(rect)
      svg.appendChild(text)

      this.src = 'data:image/svg+xml,' + encodeURIComponent(svg.outerHTML)
    },
    /***
     * Create SVG element
     * @method create
     * @param {String} name
     * @return {Element}
     * */
    create (name) {
      return document.createElementNS(this.xmlns, name)
    },
    /***
     * Set attribute to an element
     * @method attr
     * @param {Element} element
     * @param {String} attribute
     * @param {String|Number} value
     * */
    attr (element, attribute, value) {
      element.setAttribute(attribute, value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// vc-image-placeholder.vue?67538b98